var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEditRounded = function SvgIconEditRounded(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 38.5,
    height: 38.5,
    rx: 7.25,
    fill: "#FCFCFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 38.5,
    height: 38.5,
    rx: 7.25,
    stroke: "#656668",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 25.505V28.2917C12.25 28.5483 12.4517 28.75 12.7083 28.75H15.495C15.6142 28.75 15.7333 28.7042 15.8158 28.6125L25.8258 18.6117L22.3883 15.1742L12.3875 25.175C12.2958 25.2667 12.25 25.3767 12.25 25.505ZM28.4842 15.9533C28.8417 15.5958 28.8417 15.0183 28.4842 14.6608L26.3392 12.5158C25.9817 12.1583 25.4042 12.1583 25.0467 12.5158L23.3692 14.1933L26.8067 17.6308L28.4842 15.9533Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEditRounded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-edit-rounded.8cf6d2049ff1ff44cee90129306a4cbc.svg";